import { Dispatch, Store, bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
    GroupsView,
    StateProps as GroupsViewStateProps,
    DispatchProps as GroupsViewDispatchProps
} from "./components/GroupsView";
import {AppState} from 'diy/redux/app/state';
import {ModuleSectionData} from './data/payload';
import {addGroupAction, updatePayload, supportsAddGroup} from './index';
import {SectionKpiEventsTypes, emitKpiEvent} from "./tracking";
import {isModuleLimitReached} from './index';

export function onChangeColumnNumber(value: number) {
    return (dispatch: Dispatch, getState: () => AppState) => {
        emitKpiEvent(SectionKpiEventsTypes.ColumnsChanged);
        dispatch(updatePayload({columns: {active: value}} as ModuleSectionData));
    };
}

export function onChangeColumnFitMode(fitMode: number) {
    return (dispatch: Dispatch, getState: () => AppState) => {
        emitKpiEvent(SectionKpiEventsTypes.ColumnsFitChanged);
        dispatch(updatePayload({columns: {loopFit: fitMode}} as ModuleSectionData));
    };
}

function mapStateToProps(state: AppState): GroupsViewStateProps {
    const ownState = state.moduleSection;
    return {
        canAddGroup: ownState.quantity.current < ownState.quantity.max && ! isModuleLimitReached(),
        canManageColumns: ownState.columns.available.length > 0,
        availableNumberOfColumns: ownState.columns.available,
        columnFitMode: ownState.columns.loopFit,
        numberOfColumns: ownState.columns.active,
        isAddGroupAvailable: supportsAddGroup(ownState)
    };
}

function mapDispatchToProps(dispatch: Dispatch): GroupsViewDispatchProps {
    return bindActionCreators({
        onAddGroup: addGroupAction,
        onChangeColumnNumber: onChangeColumnNumber,
        onChangeColumnFitMode: onChangeColumnFitMode
    }, dispatch);
}

export function getGroupsViewComponent(store: Store) {
    const ConnectedGroupsView = connect(mapStateToProps, mapDispatchToProps)(GroupsView);

    return ConnectedGroupsView;
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/groupsTab.ts
 **/